import React from "react";
import {CatalogSearchResultError} from "../error/error";

interface Props {
    limited: boolean;
}

export const CatalogSearchResultNotFound: React.FC<Props> = ({limited}) => {

    return (
        <CatalogSearchResultError
            title={'CATALOG.NOT_FOUND.TITLE'}
            message={limited ? 'CATALOG.NOT_FOUND.LIMITED.MESSAGE': 'CATALOG.NOT_FOUND.MESSAGE'}
            />
    )
}